import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "race-card card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "header inputs"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "drivers" }
const _hoisted_7 = {
  key: 0,
  class: "guessed"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "red" }, "Voorspelling", -1)
const _hoisted_9 = { class: "result" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "red" }, "Uitslag", -1)
const _hoisted_11 = {
  key: 2,
  class: "buttons"
}

import {onMounted, ref, watch} from 'vue';
	import FetchOptions from "../interfaces/FetchOptions";
	import {FetchData} from "../utils/FetchData";
	import {DateFormatter, DateToTimestamp} from "../utils/DateFormatter";
	import {SortArrayByObjectKey} from "../utils/Sorting";
	import {RaceTypes} from "../utils/RaceTypes";
	import DriverDropdown from '../components/DriverDropdown.vue';
	import RacePoints from '../components/RacePoints.vue';
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'RaceCard',
  props: {
    race: {},
    admin: { type: Boolean },
    season: {},
    players: {},
    predictions: {},
    circuits: {}
  },
  emits: [
		'deleteRace'
	],
  setup(__props: any, { emit: __emit }) {

	const props = __props;

	const emit = __emit;

	const dateString = ref('');
	const race = ref({});

	const selectedDate = ref();

	const pickedDrivers = ref(new Array(3));
	const pickedResult = ref(new Array(3));

	const localPlayer = ref(0);
	const privileges = ref(false);

	const types = RaceTypes;

	onMounted(() => {
		localPlayer.value = JSON.parse(localStorage.player);

		const formatted = DateFormatter(props.race.date);
		dateString.value = `${formatted.date}, ${formatted.time}`;
		selectedDate.value = formatted.picker;

		race.value = JSON.parse(JSON.stringify(props.race));

		let drivers = race.value.drivers.filter(driver => driver.position != null);
		drivers = SortArrayByObjectKey(drivers, 'position');
		for(let i = 0; i < Math.min(drivers.length, 3); i++)
			pickedResult.value[drivers[i].position] = drivers[i].id;

		checkPrivileges();
	});

	watch(() => props.predictions, () => {
		if(props.predictions?.length == 0)
			return;

		const player = JSON.parse(localStorage.player);
		if(player.id == undefined)
			return;

		let array = props.predictions.filter(x => x.player_id == player.id);
		array = SortArrayByObjectKey(array, 'position');

		for(let i = 0; i < array.length; i++)
			pickedDrivers.value[i] = array[i].driver_id;
	});

	function checkPrivileges() {
		privileges.value = false;

		if(localPlayer.value.isAdmin) {
			privileges.value = true;
			return;
		}

		if(typeof (props.players) == 'object') {
			const players = props.players as object[];
			const privilegesPlayers = players.filter(x => x.pivot.privileges == 1);
			privilegesPlayers.forEach(player => {
				if(player.id == localPlayer.value.id)
					privileges.value = true;
			});
		}
	}

	function updateDriver(position: number, driverId: number) {
		pickedDrivers.value = swapDrivers(pickedDrivers.value, position, driverId);
		saveGuess();
	}

	function updateResult(position: number, driverId: number) {
		pickedResult.value = swapDrivers(pickedResult.value, position, driverId);
		saveResult();
	}

	function swapDrivers(array: (number | undefined)[], position: number, driverId: number) {
		const temp = [...array];
		const oldValue = array[position];
		let oldPosition = undefined;
		for(let i = 0; i < Math.min(array.length, 3); i++) {
			if(array[i] == driverId) {
				oldPosition = i;
				break;
			}
		}

		temp[position] = driverId;
		if(oldPosition != undefined)
			temp[oldPosition] = oldValue;

		return temp;
	}

	async function saveRace() {
		const body = JSON.parse(JSON.stringify(race.value));
		delete body.drivers;
		delete body.circuit;

		body.date = DateToTimestamp(selectedDate.value);
		body.seasons = [props.season];

		if(body.id !== undefined) {
			const options: FetchOptions = {
				method: 'PATCH',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};

			const data = await FetchData('races/' + race.value.id, options);
			if(!data.isError)
				emitter.emit('showMessage', {message: 'Race opgeslagen', header: 'Gelukt'});
		}
		else {
			const options: FetchOptions = {
				method: 'POST',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};

			const data = await FetchData('races', options);
			if(!data.isError) {
				race.value = data.data;
				emitter.emit('showMessage', {message: 'Race toegevoegd', header: 'Gelukt'});
			}
		}
	}

	function deleteRace() {
		emit('deleteRace', race.value);
	}

	function saveGuess() {
		pickedDrivers.value.forEach((driver, position) => saveDriver(driver, position));
	}

	function saveResult() {
		pickedResult.value.forEach((driver, position) => saveDriver(driver, position, true));
	}

	async function saveDriver(driverId: number|undefined, position: number, result = false) {
		if(driverId == undefined)
			return;

		if(position >= 3)
			return;

		const body = {
			race_id: props.race.pivot.id,
			driver_id: driverId,
			position: position
		};

		const options: FetchOptions = {
			method: 'POST',
			headers: {
				"Content-Type": 'application/json'
			},
			body: JSON.stringify(body)
		};

		if(!result) {
			FetchData('predictions', options);
		}
		else {
			options.method = 'PATCH';
			console.log(await FetchData('race_driver/' + race.value.id, options));
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.admin)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["header white", {upcoming: props.race.date > Date.now() / 1000}])
        }, [
          _createElementVNode("h2", null, _toDisplayString(props.race.circuit.country), 1),
          _createElementVNode("h3", null, _toDisplayString(props.race.circuit.circuit), 1),
          _createElementVNode("p", null, _toDisplayString(dateString.value), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(types)[props.race.type]), 1),
          _hoisted_2
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((race.value.circuit_id) = $event)),
            class: "circuit"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.circuits, (circuit) => {
              return (_openBlock(), _createElementBlock("option", {
                key: circuit,
                value: circuit.id
              }, _toDisplayString(circuit.country) + " - " + _toDisplayString(circuit.circuit), 9, _hoisted_4))
            }), 128))
          ], 512), [
            [_vModelSelect, race.value.circuit_id]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((race.value.type) = $event)),
            class: "type"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(types), (type, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: type,
                value: index
              }, _toDisplayString(type), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, race.value.type]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDate).value = $event)),
            class: "date",
            type: "datetime-local"
          }, null, 512), [
            [_vModelText, selectedDate.value]
          ])
        ])),
    _createElementVNode("div", _hoisted_6, [
      (!props.admin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
              return _createVNode(DriverDropdown, {
                key: index,
                drivers: race.value.drivers,
                position: index - 1,
                picked: pickedDrivers.value,
                current: pickedDrivers.value[index - 1],
                disabled: props.race.date <= Date.now() / 1000,
                right: false,
                onDriverClicked: updateDriver
              }, null, 8, ["drivers", "position", "picked", "current", "disabled"])
            }), 64))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
          return _createVNode(DriverDropdown, {
            key: index,
            drivers: race.value.drivers,
            position: index - 1,
            picked: pickedResult.value,
            current: pickedResult.value[index - 1],
            disabled: !(props.admin || privileges.value) || props.race.date > Date.now() / 1000,
            right: !props.admin,
            onDriverClicked: updateResult
          }, null, 8, ["drivers", "position", "picked", "current", "disabled", "right"])
        }), 64))
      ])
    ]),
    (props.admin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "content-box",
            onClick: deleteRace
          }, " Verwijderen "),
          _createElementVNode("button", {
            class: "content-box",
            onClick: saveRace
          }, " Opslaan ")
        ]))
      : (_openBlock(), _createBlock(RacePoints, {
          key: 3,
          predictions: props.predictions,
          players: _ctx.players,
          race: race.value
        }, null, 8, ["predictions", "players", "race"]))
  ]))
}
}

})